export default "__VITE_ASSET__dvWxrTq1__"